import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "space-y-2" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = {
  key: 0,
  class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
}
const _hoisted_6 = ["id", "type", "value", "placeholder", "disabled", "required", "autofocus"]
const _hoisted_7 = {
  key: 1,
  class: "absolute inset-y-0 right-0 pr-3 flex items-center"
}
const _hoisted_8 = {
  key: 1,
  class: "text-sm text-red-600 dark:text-red-400"
}
const _hoisted_9 = {
  key: 2,
  class: "text-sm text-gray-500 dark:text-gray-400"
}

import { computed } from 'vue'

interface Props {
  modelValue: string | number
  type?: 'text' | 'email' | 'password' | 'number' | 'url' | 'search'
  label?: string
  placeholder?: string
  error?: string
  hint?: string
  disabled?: boolean
  required?: boolean
  autofocus?: boolean
  size?: 'sm' | 'md' | 'lg'
  customClass?: string
}

interface Emits {
  (e: 'update:modelValue', value: string | number): void
  (e: 'blur', event: FocusEvent): void
  (e: 'focus', event: FocusEvent): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseInput',
  props: {
    modelValue: {},
    type: { default: 'text' },
    label: {},
    placeholder: {},
    error: {},
    hint: {},
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    autofocus: { type: Boolean, default: false },
    size: { default: 'md' },
    customClass: { default: '' }
  },
  emits: ["update:modelValue", "blur", "focus"],
  setup(__props: any) {

const props = __props



const inputId = computed(() => `input-${Math.random().toString(36).substr(2, 9)}`)

const inputClasses = computed(() => {
  const baseClasses = [
    'block w-full rounded-xl border transition-colors duration-200',
    'focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent',
    'disabled:opacity-50 disabled:cursor-not-allowed'
  ]

  // Size classes
  const sizeClasses = {
    sm: 'px-3 py-2 text-sm',
    md: 'px-4 py-2.5 text-base',
    lg: 'px-5 py-3 text-lg'
  }

  // State classes
  const stateClasses = props.error
    ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
    : 'border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400'

  return [
    ...baseClasses,
    sizeClasses[props.size],
    stateClasses,
    props.customClass
  ].filter(Boolean)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: inputId.value,
          class: "block text-sm font-medium text-gray-700 dark:text-gray-300"
        }, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.$slots['icon-left'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "icon-left")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        id: inputId.value,
        type: _ctx.type,
        value: _ctx.modelValue,
        placeholder: _ctx.placeholder,
        disabled: _ctx.disabled,
        required: _ctx.required,
        autofocus: _ctx.autofocus,
        class: _normalizeClass(inputClasses.value),
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', ($event.target as HTMLInputElement).value))),
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('blur', $event))),
        onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('focus', $event)))
      }, null, 42, _hoisted_6),
      (_ctx.$slots['icon-right'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "icon-right")
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    (_ctx.hint && !_ctx.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.hint), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})